import { NgModule } from '@angular/core';
import { ActionCoPipelineModule } from './pipe-action-co/pipe-action-co.module';
import { CataloguePipelineModule } from './pipe-catalogue/pipe-catalogue-module';
import { FormationPipelineModule } from './pipe-formation/pipe-formation.module';
import { pipeObligationModule } from './pipe-obligation/pipe-obligation.module';

@NgModule({
  imports: [
    FormationPipelineModule,
    ActionCoPipelineModule,
    CataloguePipelineModule,
    pipeObligationModule
  ],
  declarations: [  
  ],
  exports: [
  
  ]
})

export class PipelineModule { }
